export default {
  back: 'Volver',
  language: 'Cambiar idioma',
  connection: 'Estado de conexión',
  connectionMessage: 'Conexión con API de la NASA: En desarrollo'
}
